import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../../src/styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import arrowright from "../../../assets/arrowright.svg";
import ShimmerLoader from "../../../loading";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";


const SalesmanReportTable = ({ additionalData, pagination, onRowClick }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );



  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }

  }, [additionalData, flag]);

const columns = useMemo(
  () => [
    {
      Header: t("Session"),
      accessor: "session_name",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.session_name}</div>
      ),
    },
    {
      Header: t("Salesman"),
      accessor: "salesman",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.salesman}</div>
      ),
    },
    {
      Header: t("Date & Time"),
      accessor: "sale_date",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.sale_date}</div>
      ),
    },
    {
      Header: t("Barcode"),
      accessor: "barcode",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.barcode}</div>
      ),
    },
    {
      Header: t("Product Name"),
      accessor: "product_name",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.product_name}</div>
      ),
    },
    {
      Header: t("Group Name"),
      accessor: "group_name",
      Cell: ({ row }) => (
        <div className="text-start">
          {row.original.group_name || "--"}
        </div>
      ),
    },
    {
      Header: t("Quantity Sold"),
      accessor: "qty_sold",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.qty_sold}</div>
      ),
    },
    {
      Header: t("Total Cost"),
      accessor: "total_cost",
      Cell: ({ row }) => (
        <div className="text-start">
          EGP {row.original.total_cost?.toFixed(2)}
        </div>
      ),
    },
    {
      Header: t("Total Value"),
      accessor: "total_value",
      Cell: ({ row }) => (
        <div className="text-start">
          EGP {row.original.total_value?.toFixed(2)}
        </div>
      ),
    },
    {
      Header: t("Payment Method"),
      accessor: "payment_method",
      Cell: ({ row }) => (
        <div className="text-start">
          {t(row.original.payment_method)}
        </div>
      ),
    },
    {
      Header: t("Discount"),
      accessor: "discount",
      Cell: ({ row }) => (
        <div className="text-start">
          EGP {row.original.discount?.toFixed(2)}
        </div>
      ),
    },
    {
      Header: t("Profit %"),
      accessor: "profit_percentage",
      Cell: ({ row }) => (
        <div className="text-start">
          {row.original.profit_percentage != null
            ? `${row.original.profit_percentage}%`
            : "--"}
        </div>
      ),
    },
    ...(allStores
      ? [
          {
            Header: t("Store Name"),
            accessor: "store_name",
            Cell: ({ row }) => (
              <div className="text-start">{row.original.store_name}</div>
            ),
          },
        ]
      : []),
  ],
  [t, allStores]
);


  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setPageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  const handlePageSizeChange = (newPageSize) => {
    // Ensure the current page doesn't exceed the total available pages
    const maxPageIndex = Math.ceil(data.length / newPageSize);
    if (pageIndex > maxPageIndex) {
      setPageIndex(maxPageIndex); // Adjust the pageIndex to the last available page
    }

    setPageSize(newPageSize);
  };

  return (
   <div className="mt-4  w-full">
            {additionalData?.length === 0 && !flag ? (
                <div className="h-screen w-full mt-2">
                    <ShimmerLoader />
                </div>
            ) : (
                <div className="overflow-x-auto border rounded-lg">
                    {/* Table with sticky headers */}
                    <table className="min-w-[1200px] w-full border-collapse">
                        <thead className="bg-[#78CFEC66] sticky top-0 z-10">
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            style={{ width: column.width }}
                                            className="py-2 px-2 text-left text-sm font-semibold whitespace-nowrap"
                                        >
                                          <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                         {column.render("Header")}
                                                                         {column.canSort && (
                                                                           <span className="ms-1">
                                                                             {column.isSorted ? (
                                                                               column.isSortedDesc ? (
                                                                                 <img
                                                                                   src={Vectorsorting}
                                                                                   style={{
                                                                                     minHeight: 10,
                                                                                     minWidth: 10,
                                                                                   }}
                                                                                   alt="vector"
                                                                                 />
                                                                               ) : (
                                                                                 <img
                                                                                   className="rotate-180"
                                                                                   src={Vectorsorting}
                                                                                   alt="vector"
                                                                                 />
                                                                               )
                                                                             ) : (
                                                                               // 👇 Show a neutral icon when column is not sorted
                                                                               <img
                                                                                 src={Vectorsorting}
                                                                                 alt="sortable"
                                                                                 style={{
                                                                                   minHeight: 10,
                                                                                   minWidth: 10,
                                                                                   opacity: 0.3,
                                                                                 }}
                                                                               />
                                                                             )}
                                                                           </span>
                                                                         )}
                                                                       </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <tbody className="bg-[#F7F9FD] text-center">
                            {page.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr
                                        {...row.getRowProps()}
                                        className="hover:bg-white cursor-pointer border-b border-gray-300"
                                        onClick={() => onRowClick && onRowClick(row.original)}
                                    >
                                        {row.cells.map((cell) => (
                                            <td
                                                {...cell.getCellProps()}
                                                className="p-2 text-[13px] font-normal text-left"
                                                style={{ width: cell.column.width }}
                                            >
                                                {cell.render("Cell")}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                            {page.length === 0 && (
                                <tr>
                                    <td colSpan={columns.length}>
                                        <Empty
                                            className="mt-10"
                                            description={t("No data available")}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Pagination */}
            <div className="mt-4">
                <CustomPagination
                    data={data?.length}
                    pageIndex={pageIndex}
                    pageCount={page?.length}
                    canPreviousPage={pageIndex !== 1}
                    canNextPage={data?.length === pageSize}
                    gotoPage={(p) => {
                        nextPage(p);
                    }}
                    previousPage={() => setPageIndex(pageIndex - 1)}
                    nextPage={() => setPageIndex(pageIndex + 1)}
                    pageSize={pageSize}
                    setPageSize={handlePageSizeChange}
                />
            </div>
        </div>
  );
};

export default SalesmanReportTable;
